export function getLogoTitle() {
  return 'Buchbutler.de - Barsortiment on demand';
}

export function getTelTitle() {
  return 'persönlicher Kundenservice - Buchbutler anrufen';
}

export function getTelNummber() {
  return '02571/8 07 28 80';
}

export function getTelNummberLink() {
  return 'tel:+4925718072880';
}

export function getHeaderInjection() {
  return null;
}
